module.exports = __webpack_public_path__ + "media/images/ups-white-689ffe8f.png";